import { render, staticRenderFns } from "./DanhMucTinTucList.vue?vue&type=template&id=39eb9660&"
import script from "./DanhMucTinTucList.vue?vue&type=script&lang=js&"
export * from "./DanhMucTinTucList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports